/* istanbul ignore file */
import { useEffect } from 'react'

type UseCloseEscapeProps = {
  isPopupOpened: boolean
  closePopup: () => void
  triggerRef: React.RefObject<HTMLDivElement>
}

/**
 * Close the popup when the escape key is pressed.
 * @param isPopupOpened - whether the popup is opened
 * @param closePopup - function to close the popup
 * @param triggerRef - ref to the trigger element to back focus when the popup is closed
 */
export const useCloseEscape = ({ isPopupOpened, closePopup, triggerRef }: UseCloseEscapeProps) => {
  useEffect(() => {
    const handleEscapeKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && isPopupOpened) {
        closePopup()
        triggerRef.current?.focus()
      }
    }

    if (isPopupOpened) {
      document.addEventListener('keydown', handleEscapeKey)
    }

    return () => {
      document.removeEventListener('keydown', handleEscapeKey)
    }
  }, [isPopupOpened])
}
